import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { AppButton } from '../../Components/index.js'
import { useStyles } from './style.js'

const NoPermission = (props) => {
  const classes = useStyles()
  const history = useHistory()
  return (
    <div className={classes.headerWrapper}>
      <div className={classes.content}>You do not have permission to access any page.</div>
      <AppButton text="Manage Account" onClick={() => history.push('/accounts')} />
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin } = auth
  return { currentUser, isSuperAdmin }
}

export default connect(mapStateToProps, {})(NoPermission)